import constants from '../constants';

const { RUNTIME_CONTAINER_CLASS } = constants;

function ejectCustomHtml(staticNode) {
  const runtimeContainers = staticNode.querySelectorAll(`.${RUNTIME_CONTAINER_CLASS}`);

  runtimeContainers.forEach((runtimeContainer) => {
    runtimeContainer.remove();
  });

  return staticNode;
}

export default ejectCustomHtml;
